
import { ChevronDownIcon } from 'vue-feather-icons';
export default {
  data() {
    return {
      linkWrapperHovred: -1,
    };
  },
  computed: {
    menuData() {
      return this.$store.state.shop.menu.data;
    },

    menuTabs() {
      return this.menuData?.TabBarDatas;
    },
  },
  methods: {
    linkWrapperMouseEnter(index) {
      this.linkWrapperHovred = index;
    },
    linkWrapperMouseLeave() {
      this.linkWrapperHovred = -1;
    },

    getSafeLink(link) {
      if (link?.includes('http')) {
        const parsedUrl = new URL(link); // Create a URL object
        return parsedUrl.pathname;
      } else {
        return this.localePath('/' + link);
      }
    },
  },
  components: {
    ChevronDownIcon,
  },
};
